import PropTypes from "prop-types";
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import { Link } from "react-router-dom";

const BreadcrumbWrap = ({pages, leftContent, rightContent}) => {
  const items = pages?.map(({ path, label }, i) =>
    i !== pages.length - 1 ? (
      <Breadcrumb.Item key={label} linkProps={{ to: path }} linkAs={Link}>
        {label}
      </Breadcrumb.Item>
    ) : (
      <Breadcrumb.Item key={label} active>
        {label}
      </Breadcrumb.Item>
    )
  );

  return (
    <div className="breadcrumb-area pt-35 pb-35 bg-gray-3">
      <div className="container">
        {/*
        <Breadcrumb>
            {pages?.map(({ path, label }, i) => i !== pages.length - 1 ? (
                <Breadcrumb.Item key={label} linkProps={{to: path}} linkAs={Link}>
                  {label}
                </Breadcrumb.Item>
            ) : (                
              <Breadcrumb.Item key={label} active>
                {label}
              </Breadcrumb.Item>
            ))}
        </Breadcrumb>
        */}

        {leftContent || rightContent ? (
          <>
            {/* Side content (e.g. products page): breadcrumb centered on top, info split left / right below */}
            <Breadcrumb className="mb-2" listProps={{ className: 'justify-content-center' }}>
              {items}
            </Breadcrumb>
            <div className="row">
              <div className="col-md-6">{leftContent}</div>
              <div className="col-md-6 text-md-end">{rightContent}</div>
            </div>
          </>
        ) : (
          <div className="row align-items-center">
            <div className="col-12 text-end">
              <Breadcrumb className="mb-0 justify-content-end">{items}</Breadcrumb>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

BreadcrumbWrap.propTypes = {
  pages: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      path: PropTypes.string.isRequired,
    })
  ).isRequired,
  leftContent: PropTypes.node,
  rightContent: PropTypes.node,
};

export default BreadcrumbWrap;